export default "__VITE_ASSET__b74b21ac__"